import { rem } from '@mantine/core';

export const imagesPath = '/images' as const;
export const iconsPath = '/icons' as const;
export const gifsPath = '/gifs' as const;
export const SIDEBAR_WIDTH_VALUE = 240 as const;
export const SIDEBAR_WIDTH = rem(240);
